import Vue from 'vue'
import App from './App.vue'
import router from './router'  //引入 vue-router
import './assets/icons'
import ElementUI from 'element-ui'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import uploader from 'vue-simple-uploader'
import SlideUpDown from 'vue-slide-up-down'
import VueContextMenu from 'vue-contextmenu'

import '../../common-components/src/styles/common.scss' // 自定义组件样式汇总
import '../../common-components/src/styles/icon/scss/icon.scss'
import '../../common-components/src/styles/icon/iconfont/iconfont.js'
import ucLoading from '../../common-components/src/components/Loading/loadingIndex'      //自定义加载
import ucEmpty from '../../common-components/src/components/CustomEmpty/empty-index'     //自定义空状态
import api from "../src/api/config"
import {buttonBlur, hideTooltips, enterTooltip} from "../../common-components/src/utils/commonUtil";
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, Axios)
Vue.use(uploader)
Vue.use(VueContextMenu)
Vue.component("ucEmpty", ucEmpty)
Vue.component('slide-up-down', SlideUpDown)
Vue.prototype.ucloading = ucLoading
Vue.prototype.$api = api
Vue.prototype.$buttonBlur = buttonBlur;
Vue.prototype.$enterTooltip = enterTooltip;
Vue.prototype.$hideTooltips = hideTooltips;
Vue.prototype.$chunckSize = 1024 * 1024 * 5; //文件上传分片大小

//axios拦截器做预处理
Axios.interceptors.request.use(config => {
  //请求缓存处理,
  if(config.url.indexOf('?')>-1){
    config.url = config.url + '&timestamp='+new Date().getTime();
  }else{
    config.url = config.url + '?timestamp='+new Date().getTime();
  }
  return config
}, error => {
  return Promise.reject(error)
})
Axios.interceptors.response.use(response => {
  if (!response.data.success && response.data.errorCode === -503){
    window.location.href = "/teacher/login";
  }
  return response
}, error => {
  console.log(error);
  return Promise.resolve(error.response)
})

//覆盖$message
Vue.prototype.$messageZ = Vue.prototype.$message;
Vue.prototype.$message = function(msg, duration, option){
  return ElementUI.Message({
    message: msg,
    duration: null != duration ? duration : 3000,
    ...option
  })
}
Vue.prototype.$message.success = function (msg, duration, option) {
  return ElementUI.Message.success({
    message: msg,
    duration: null != duration ? duration : 3000,
    ...option
  })
}
Vue.prototype.$message.warning = function (msg, duration, option) {
  return ElementUI.Message.warning({
    message: msg,
    duration: null != duration ? duration : 3000,
    ...option
  })
}
Vue.prototype.$message.info = function (msg, duration, option) {
  return ElementUI.Message.info({
    message: msg,
    duration: null != duration ? duration : 3000,
    ...option
  })
}
Vue.prototype.$message.error = function (msg, duration, option) {
  return ElementUI.Message.error({
    message: msg,
    duration: null != duration ? duration : 3000,
    ...option
  })
}

new Vue({
  router,
  render: h => h(App),
  store,
  data: function (){
    return {
      resourceServer: '',
      uclassServer: '',
      recycleValidTime: 30
    }
  },
  mounted() {

  },
  methods: {

  },
}).$mount('#app')
